import * as React from "react";
import {connect} from "react-redux";
import update from 'immutability-helper';
import * as ClientsAction from "../actions/ClientActions";
import * as ProjectsAction from "../actions/ProjectActions";
import * as TasksAction from "../actions/TaskActions";
import {
    Button, Col, FormControl, FormGroup, Glyphicon, InputGroup, Row, ToggleButton,
    ToggleButtonGroup
} from "react-bootstrap";
import * as UsersAction from "../actions/UserActions";
import moment from "moment";
import * as EntryActions from "../actions/EntryActions";
import Loading from "../components/Loading";
import EntryTable from "../components/EntryTable";
import EntryByTaskTable from "../components/EntryByTaskTable";
import * as utils from "../utils";
import queryString from 'query-string';
import {
    ALL_TIME_FROM, ALL_TIME_TO, SHORTCUT, FORMAT_REPORTING, NO_ITEM_SELECTED_VALUE,
    ALL_TIME_TEXT, ALL_TIME_TEXT_URL
} from "../constants";
import FirstTimeSetup from "../components/FirstTimeSetup";
import {needsSetup} from "../utils";


const PERIODS = {
    [SHORTCUT.THIS_WEEK] : {
        from: moment().startOf("isoWeek"),
        to: moment().endOf("isoWeek")
    },
    [SHORTCUT.THIS_MONTH] : {
        from: moment().startOf("month"),
        to: moment().endOf("month")
    },
    [SHORTCUT.LAST_WEEK] : {
        from: moment().subtract(1, "week").startOf("isoWeek"),
        to: moment().subtract(1, "week").endOf("isoWeek")
    },
    [SHORTCUT.LAST_MONTH] : {
        from: moment().subtract(1, "month").startOf("month"),
        to: moment().subtract(1, "month").endOf("month")
    },
    [SHORTCUT.ALL_TIME] : {
        from: ALL_TIME_FROM,
        to: ALL_TIME_TO
    }
};

const VIEW = {
    ENTRIES: "entries",
    TASKS: "tasks"
};

class ReportingPage extends React.Component{

    constructor(){
        super();

        this.state = {
            period: {
                from: PERIODS[SHORTCUT.THIS_WEEK].from,
                to: PERIODS[SHORTCUT.THIS_WEEK].to,
            },
            shortcut: SHORTCUT.THIS_WEEK,
            view: VIEW.TASKS,
            form: {
                client_id: undefined,
                project_id: undefined,
                task_id: undefined,
                user_id: undefined,
                from: PERIODS[SHORTCUT.THIS_WEEK].from.format(FORMAT_REPORTING),
                to: PERIODS[SHORTCUT.THIS_WEEK].to.format(FORMAT_REPORTING),
            },
            filters: {},
            validationStates: {
                from: null,
                to: null,
            },
            cacheTag: null,
        };
    }

    async componentDidMount() {
        this.props.fetchClientsIfNeeded();
        this.props.fetchProjectsIfNeeded();
        this.props.fetchTasksIfNeeded();
        this.props.fetchUsersIfNeeded();

        const search = queryString.parse(this.props.location.search);

        if (Object.values(search).length > 0) {
            const setState = () => {
                this.setState(update(this.state, {
                    form: {
                        client_id: {$set: search.client},
                        project_id: {$set: search.project},
                        task_id: {$set: search.task},
                        user_id: {$set: search.user},
                        from: {$set: search.from === ALL_TIME_TEXT_URL ? ALL_TIME_TEXT : search.from},
                        to: {$set: search.to === ALL_TIME_TEXT_URL ? ALL_TIME_TEXT : search.to},
                    },
                    period: {
                        from: {$set: search.from === ALL_TIME_TEXT_URL ? ALL_TIME_FROM : moment(search.from, FORMAT_REPORTING)},
                        to: {$set: search.to === ALL_TIME_TEXT_URL ? ALL_TIME_TO : moment(search.to, FORMAT_REPORTING)},
                    },
                    shortcut: {$set: search.from === ALL_TIME_TEXT_URL && search.to === ALL_TIME_TEXT_URL ? SHORTCUT.ALL_TIME : SHORTCUT.CUSTOM}
                }));
            };

            await setState();
            this.search();
        }
    }

    handleChange(event) {
        let newState = update(this.state, {
            form: {
                [event.target.name]: {$set: event.target.value}
            }
        });

        if(event.target.name === "project_id"){
            newState = update(newState, {
                form: {
                    task_id: {$set: NO_ITEM_SELECTED_VALUE}
                }
            })
        }

        if(event.target.name === "client_id"){
            newState = update(newState, {
                form: {
                    project_id: {$set: NO_ITEM_SELECTED_VALUE},
                    task_id: {$set: NO_ITEM_SELECTED_VALUE},
                }
            });
        }

        if(event.target.name === "task_id" && event.target.value !== NO_ITEM_SELECTED_VALUE){
            newState = update(newState, {
                view: {$set: VIEW.ENTRIES}
            })
        }

        // const {client_id, project_id, task_id, user_id} = newState.form;
        // this.props.history.push({
        //     search: queryString.stringify({
        //         client: client_id !== NO_ITEM_SELECTED_VALUE ? client_id : undefined,
        //         project: project_id !== NO_ITEM_SELECTED_VALUE ? project_id : undefined,
        //         task: task_id !== NO_ITEM_SELECTED_VALUE ? task_id : undefined,
        //         user: user_id !== NO_ITEM_SELECTED_VALUE ? user_id : undefined,
        //     })
        // });

        this.setState(newState);
    }

    handleChangePeriod(event){
        const action = event.target.name;

        const date = moment(event.target.value, FORMAT_REPORTING);

        this.setState(update(this.state, {
            period: {
                [action]: {$set: date}
            },
            form: {
                [action]: {$set: event.target.value}
            },
            validationStates: {
                [action]: {$set: date.isValid() ? null : "error"}
            }
        }))
    }
    onBlurPeriod(event){
        const action = event.target.name;

        if(!this.state.period[action].isValid()) return;

        this.updateInputFields(this.state.period, update(this.state, {
            shortcut: {$set: SHORTCUT.CUSTOM}
        }));
    }

    updateInputFields(period, state = this.state){
        this.setState(update(state, {
            form: {
                from: {$set: period.from.isValid() && period.from.diff(ALL_TIME_FROM) === 0 ? ALL_TIME_TEXT : period.from.format(FORMAT_REPORTING)},
                to: {$set: period.to.isValid() && period.to.diff(ALL_TIME_TO) === 0 ? ALL_TIME_TEXT : period.to.format(FORMAT_REPORTING)},
            }
        }))
    }

    onChangeShortcut(shortcut){
        this.updateInputFields(PERIODS[shortcut], update(this.state,{
            period: {$set: PERIODS[shortcut]},
            shortcut: {$set: shortcut}
        }));
    }

    onChangeView(view){
        this.setState({view})
    }

    getCacheTag(){
        const {client_id, project_id, task_id, user_id} = this.state.form;
        const {period} = this.state;
        return client_id + "-" + project_id + "-" + task_id + "-" + user_id + period.from.format(FORMAT_REPORTING) + "-" + period.to.format(FORMAT_REPORTING);
    }

    search(){
        const cacheTag = this.getCacheTag();

        const {client_id, project_id, task_id, user_id} = this.state.form;

        this.props.fetchFilteredEntries(update(this.state.form, {
            from: {$set: this.state.period.from},
            to: {$set: this.state.period.to},
            client_id : {$set: client_id === NO_ITEM_SELECTED_VALUE ? undefined : client_id},
            project_id : {$set: project_id === NO_ITEM_SELECTED_VALUE ? undefined : project_id},
            task_id : {$set: task_id === NO_ITEM_SELECTED_VALUE ? undefined : task_id},
            user_id : {$set: user_id === NO_ITEM_SELECTED_VALUE ? undefined : user_id},
        }), cacheTag);

        let filters = this.state.filters;
        filters[cacheTag] = {
            client_id, project_id, task_id, user_id,
            period: this.state.period.from.diff(ALL_TIME_FROM) === 0 ? undefined : {
                from: this.state.period.from,
                to: this.state.period.to,
            }
        };

        this.setState({
            cacheTag: cacheTag,
            filters,
        });
    }

    export(){
        utils.exportEntries("Report", Object.values(this.props.entries.filteredItems[this.state.cacheTag]), this.props.tasks, this.props.users, this.props.clients, this.props.projects);
    }

    async onTaskClick(task) {
        const setState = () => {
            this.setState(update(this.state, {
                form: {
                    client_id: {$set: task.client.id},
                    project_id: {$set: task.project.id},
                    task_id: {$set: task.id}
                },
                view: {$set: VIEW.ENTRIES}
            }))
        };

        await setState();
        this.search();
    }

    render(){

        const {clients, projects, tasks, user, users, entries, needsSetup} = this.props;
        const {form} = this.state;

        if(needsSetup) return <FirstTimeSetup />;

        const clientsArray = Object.values(clients.items).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        const projectsArray = Object.values(projects.items);
        const tasksArray = Object.values(tasks.items);
        const usersArray = Object.values(users.items).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

        const filteredProjects = form.client_id ? projectsArray.filter(project => project.client.id === form.client_id).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) : [];
        const filteredTasks = form.project_id ? tasksArray.filter(task => task.project.id === form.project_id).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) : [];

        const filteredEntries = Object.values(entries.filteredItems[this.state.cacheTag] || {}).sort((a, b) => a.date > b.date);

        let emptyMessage =  "";
        if (this.state.cacheTag) {
            emptyMessage = entries.isFetching[this.state.cacheTag] ? "Loading..." : "No entries found";
        }

        let grandTotalMinutes = 0;
        let totalMinutes = {};
        // if (this.state.view === VIEW.TASKS) {
            let usedTasks = {};
            filteredEntries.forEach(entry => {
                if(!usedTasks[entry.task.id]) usedTasks[entry.task.id] = tasks.items[entry.task.id];
                if(!totalMinutes[entry.task.id]) totalMinutes[entry.task.id] = 0;
                totalMinutes[entry.task.id] += entry.minutes;
                grandTotalMinutes += entry.minutes;
            });
            let usedTasksArray = Object.values(usedTasks).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        // }

        let sentence = null;
        if (filteredEntries.length > 0) {
            let filters = this.state.filters[this.state.cacheTag];
            let count = this.state.view === VIEW.ENTRIES ? filteredEntries.length : usedTasksArray.length;
            let views = {
                [VIEW.ENTRIES]: {
                    "plural": "entries",
                    "single": "entry",
                },
                [VIEW.TASKS]: {
                    "plural": "tasks",
                    "single": "task",
                },
            };
            let client = (filters.client_id === undefined || filters.client_id === NO_ITEM_SELECTED_VALUE) ? "" : " from client " + clients.items[filters.client_id].name;
            let project = (filters.project_id === undefined || filters.project_id === NO_ITEM_SELECTED_VALUE) ? "" : ", project " + projects.items[filters.project_id].name;
            let task = (filters.task_id === undefined || filters.task_id === NO_ITEM_SELECTED_VALUE) ? "all tasks" : "task '" + tasks.items[filters.task_id].name + "'";

            let what = views[this.state.view][(count === 1) ? "single" : "plural"];

            let period = "";
            if (filters.period){
                period = " " + (this.state.view === VIEW.TASKS ? "that have hours registered" : "") + " between " + filters.period.from.format("D MMMM YYYY") + " and " + filters.period.to.format("D MMMM YYYY");
            }

            let user = (filters.user_id === undefined || filters.user_id === NO_ITEM_SELECTED_VALUE) ? "" : " by " + users.items[filters.user_id].name;
            let totalHours = utils.formatHoursAsObject(grandTotalMinutes);
            let total = " totalling " + totalHours.hours + " hour";
            if(parseInt(totalHours.minutes, 10) > 0)total +=" and " + parseInt(totalHours.minutes, 10) + " minutes";

            sentence = <div>
                Showing {count} {what}{client}{project}{this.state.view === VIEW.ENTRIES && (" and " + task)}{}{period}{user}{total}.
            </div>
        }

        return (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        Reporting
                        <Loading right loading={entries.isFetching[this.state.cacheTag]}/>
                    </h1>
                </div>
                <div className="card-body">
                    <Row>
                        <Col xs={4} className="visible-xs">
                            <ToggleButtonGroup type="radio" bsSize="small" vertical name="period" onChange={this.onChangeShortcut.bind(this)} defaultValue={SHORTCUT.THIS_WEEK} value={this.state.shortcut}>
                                <ToggleButton value={SHORTCUT.THIS_WEEK}>this week</ToggleButton>
                                <ToggleButton value={SHORTCUT.THIS_MONTH}>this month</ToggleButton>
                                <ToggleButton value={SHORTCUT.LAST_WEEK}>last week</ToggleButton>
                                <ToggleButton value={SHORTCUT.LAST_MONTH}>last month</ToggleButton>
                                <ToggleButton value={SHORTCUT.ALL_TIME}>all time</ToggleButton>
                            </ToggleButtonGroup>
                        </Col>
                        <Col sm={3} xs={8}>
                            <FormGroup style={{marginBottom: "10px"}} validationState={this.state.validationStates.from}>
                                <InputGroup>
                                    <InputGroup.Addon>FROM</InputGroup.Addon>
                                    <FormControl componentClass="input" name="from" id="from"
                                                 placeholder="From (dd-mm-yyyy)"
                                                 value={this.state.form.from}
                                                 onChange={this.handleChangePeriod.bind(this)} onBlur={this.onBlurPeriod.bind(this)} />
                                    <FormControl.Feedback />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col sm={3} xs={8}>
                            <FormGroup style={{marginBottom: "0"}} validationState={this.state.validationStates.to}>
                                <InputGroup>
                                    <InputGroup.Addon>TO</InputGroup.Addon>
                                    <FormControl componentClass="input" name="to" id="to"
                                                 placeholder="To (dd-mm-yyyy)"
                                                 value={this.state.form.to}
                                                 onChange={this.handleChangePeriod.bind(this)} onBlur={this.onBlurPeriod.bind(this)} />
                                </InputGroup>
                                <FormControl.Feedback />
                            </FormGroup>
                        </Col>
                        <Col sm={6} xs={12} className="hidden-xs">
                            <ToggleButtonGroup type="radio" name="period" onChange={this.onChangeShortcut.bind(this)} defaultValue={SHORTCUT.THIS_WEEK} value={this.state.shortcut}>
                                <ToggleButton value={SHORTCUT.THIS_WEEK}>this week</ToggleButton>
                                <ToggleButton value={SHORTCUT.THIS_MONTH}>this month</ToggleButton>
                                <ToggleButton value={SHORTCUT.LAST_WEEK}>last week</ToggleButton>
                                <ToggleButton value={SHORTCUT.LAST_MONTH}>last month</ToggleButton>
                                <ToggleButton value={SHORTCUT.ALL_TIME}>all time</ToggleButton>
                            </ToggleButtonGroup>
                        </Col>
                    </Row>
                    <Row className="row-spacing">
                        <Col sm={3} xs={12}>
                            <FormControl componentClass="select" name="client_id"
                                         onChange={this.handleChange.bind(this)}
                                         value={this.state.form.client_id}>
                                <option value={NO_ITEM_SELECTED_VALUE}>All Clients</option>
                                {clientsArray.map((client, i) => (
                                    <option key={i} value={client.id}>{client.name}</option>
                                ))}
                            </FormControl>
                        </Col>
                        <Col sm={3} xs={12}>
                            <FormControl componentClass="select" name="project_id"
                                         onChange={this.handleChange.bind(this)}
                                         value={this.state.form.project_id}>
                                <option value={NO_ITEM_SELECTED_VALUE}>All projects</option>
                                {filteredProjects.map((project, i) => (
                                    <option key={i} value={project.id}>{project.name}</option>
                                ))}
                            </FormControl>
                        </Col>
                        <Col sm={3} xs={12}>
                            <FormControl componentClass="select" name="task_id"
                                         onChange={this.handleChange.bind(this)}
                                         value={this.state.form.task_id}>
                                <option value={NO_ITEM_SELECTED_VALUE}>All tasks</option>
                                {filteredTasks.map((task, i) => (
                                    <option key={i} value={task.id}>{task.name}</option>
                                ))}
                            </FormControl>
                        </Col>
                        <Col sm={3} xs={12}>
                            <FormControl componentClass="select" name="user_id"
                                         onChange={this.handleChange.bind(this)}
                                         value={this.state.form.user_id}>
                                <option value={NO_ITEM_SELECTED_VALUE}>All users</option>
                                {usersArray.map((user, i) => (
                                    <option key={i} value={user.id}>{user.name}</option>
                                ))}
                            </FormControl>
                        </Col>
                    </Row>
                    <Row className="row-spacing">
                        <Col sm={3} xs={7}>
                            <ToggleButtonGroup type="radio" name="view" onChange={this.onChangeView.bind(this)} defaultValue={VIEW.TASKS} value={this.state.view}>
                                <ToggleButton value={VIEW.TASKS}>Tasks</ToggleButton>
                                <ToggleButton value={VIEW.ENTRIES}>Entries</ToggleButton>
                            </ToggleButtonGroup>
                        </Col>
                        <Col sm={5} className="hidden-xs">

                            {sentence}

                        </Col>
                        <Col sm={4} xs={5} style={{textAlign: "right"}}>
                            {filteredEntries.length > 0 && (
                                <Button onClick={this.export.bind(this)} style={{marginRight: "10px"}}>
                                    <Glyphicon glyph="download"/>
                                    <span className="hidden-xs">&nbsp;Download</span>
                                </Button>
                            )}
                            <Button bsStyle="primary" onClick={this.search.bind(this)} disabled={entries.isFetching[this.state.cacheTag]}>
                                <Glyphicon glyph="search"/>
                                <span className="hidden-xs">&nbsp;Search</span>
                            </Button>
                        </Col>
                        <Col xs={12} className="visible-xs" style={{marginTop: "8px"}}>{sentence}</Col>
                    </Row>
                </div>

                {this.state.view === VIEW.TASKS ? (
                    <EntryByTaskTable
                        entries = {filteredEntries}
                        clients = {clients}
                        tasks = {tasks}
                        projects = {projects}
                        users = {users}
                        activeUser = {user}
                        empty = {emptyMessage}
                        showTeam = {true}
                        onItemClick = {this.onTaskClick.bind(this)}
                        usedTasksArray = {usedTasksArray}
                        totalMinutes = {totalMinutes}
                        grandTotalMinutes = {grandTotalMinutes}
                    />
                ) : (
                    <EntryTable
                        entries = {filteredEntries}
                        clients = {clients}
                        tasks = {tasks}
                        projects = {projects}
                        users = {users}
                        activeUser = {user}
                        showTeam = {true}
                        empty={emptyMessage} />
                )}
            </div>
        );
    }
}

export default connect(state => ({
    clients: state.clients,
    projects: state.projects,
    tasks: state.tasks,
    users: state.users,
    entries: state.entries,
    user: state.users.active,
    needsSetup: needsSetup(state),
}), dispatch => ({
    fetchClientsIfNeeded: () => dispatch(ClientsAction.fetchClientsIfNeeded()),
    fetchProjectsIfNeeded: () => dispatch(ProjectsAction.fetchProjectsIfNeeded()),
    fetchTasksIfNeeded: () => dispatch(TasksAction.fetchTasksIfNeeded()),
    fetchUsersIfNeeded: () => dispatch(UsersAction.fetchUsersIfNeeded()),
    fetchFilteredEntries: (params, key) => dispatch(EntryActions.fetchFilteredEntries(params, key)),
}))(ReportingPage);


// WEBPACK FOOTER //
// ./src/pages/ReportingPage.js